import { useState, useEffect } from "react";

const RangeSlider = ({ min = 0, max = 100, step = 1, value, onChange, label, showValue = true }) => {
  const [sliderValue, setSliderValue] = useState(value || min);

  useEffect(() => {
    setSliderValue(value || min);
  }, [value, min]);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setSliderValue(newValue);
    onChange?.(newValue);
  };

  const calculateBackground = () => {
    const percentage = ((sliderValue - min) / (max - min)) * 100;
    return `linear-gradient(to right, #e11d48 ${percentage}%, #e5e7eb ${percentage}%)`;
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        {label && <span className="text-sm font-medium text-gray-700">{label}</span>}
        {showValue && (
          <span className="text-sm font-medium bg-rose-50 text-rose-600 px-2 py-1 rounded">
            {sliderValue}%
          </span>
        )}
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={sliderValue}
        onChange={handleChange}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer range-slider"
        style={{
          background: calculateBackground(),
          WebkitAppearance: "none",
        }}
      />
      <style>{`
        .range-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          background: #e11d48;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.15s ease-in-out;
          box-shadow: 0 2px 4px rgba(225, 29, 72, 0.3);
        }
        .range-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
          box-shadow: 0 3px 6px rgba(225, 29, 72, 0.4);
        }
        .range-slider::-moz-range-thumb {
          width: 18px;
          height: 18px;
          background: #e11d48;
          border-radius: 50%;
          cursor: pointer;
          border: none;
          transition: all 0.15s ease-in-out;
          box-shadow: 0 2px 4px rgba(225, 29, 72, 0.3);
        }
        .range-slider::-moz-range-thumb:hover {
          transform: scale(1.1);
          box-shadow: 0 3px 6px rgba(225, 29, 72, 0.4);
        }
      `}</style>
    </div>
  );
};

export default RangeSlider; 